import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, finalize, Observable, tap, throwError } from 'rxjs';
import Swal from 'sweetalert2';
import { UserIpService } from './UserIpService/userIp.service';
import { SwalAlertService } from './SwalAlertService/swalAlert.service';

@Injectable()
export class InterceptorService implements HttpInterceptor {
  constructor(
    private userIpService: UserIpService,
    public swalAlert: SwalAlertService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token = localStorage.getItem('token')?.replaceAll('"', ' ');
    let authReq = req;

    let ip = localStorage.getItem('ipv4') ?? '';

    if (
      token &&
      !req.url.includes('viacep') &&
      !req.url.includes('ipify') &&
      !req.url.includes('ImprimirTicket') &&
      !req.url.includes('Login')
    ) {
      authReq = req.clone({
        setHeaders: {
          'Access-Control-Allow-Origin': '*',
          type: 'application/json',
          Authorization: `Bearer ${token}`,
          ipv4: String(ip)
        }
      });
    }

    return next.handle(authReq).pipe(
      tap((response: any) => {
        const status = [200, 201];

        if (status.includes(response.status) && authReq.method !== 'GET') {
          if (authReq.method == 'POST' && !authReq.url.includes('Login')) {
            this.swalAlert.showAlert(
              'Sucesso!',
              'Cadastro realizado com sucesso.',
              'success'
            );
          }

          if (authReq.method == 'PUT') {
            this.swalAlert.showAlert(
              'Sucesso!',
              'Edição realizada com sucesso.',
              'success'
            );
          }

          if (authReq.method == 'PATCH') {
            this.swalAlert.showAlert(
              'Sucesso!',
              'Alteração realizada com sucesso.',
              'success'
            );
          }
        }
      }),
      catchError((error: HttpErrorResponse) => {
        const errorMessage = '';

        if (error.error && error.error.Errors) {
          if (error.error.Errors.Error) {
            const mensagensErro = error.error.Errors.Error;
            this.swalAlert.showAlert(
              'Alerta!',
              mensagensErro,
              'warning',
              true,
              false,
              { width: '50%' }
            );
          } else {
            const mensagensErro = error.error.Errors;
            this.swalAlert.showAlert(
              'Alerta!',
              mensagensErro,
              'warning',
              true,
              false,
              { width: '50%' }
            );
          }

          return throwError(errorMessage);
        }

        if (error.error) {
          let errorMessage = error.error;
          let listError;
          let errorMessageStyle =
            '<div style="max-height: 30vh; overflow-y: auto; text-align: left;"><ul>';

          listError =
            typeof errorMessage === 'string'
              ? JSON.parse(errorMessage)
              : errorMessage;

          listError.forEach((x: any, index: number) => {
            if (index > 0) {
              errorMessageStyle += '<br>';
            }
            errorMessageStyle += `• ${x}` + '<br>';
          });

          errorMessageStyle += '</ul>';
          this.swalAlert.showAlert(
            'Alerta!',
            errorMessageStyle,
            'warning',
            true,
            false,
            { width: '50%' }
          );
          return throwError(errorMessage);
        } else {
          this.swalAlert.showAlert(
            'Alerta!',
            'Ocorreu um erro ao realizar a operação, tente novamente.',
            'warning'
          );
          return throwError(errorMessage);
        }
      }),
      finalize(() => {})
    );
  }
}
